import * as React from 'react'
import * as ReactDOM from 'react-dom'
import {
  progressBarFetch,
  setOriginalFetch,
  ProgressBar,
} from 'helpers/react-progressbar'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, store } from 'helpers/configureStore'
import * as Sentry from '@sentry/browser'
import App from './app'
import ReactGA from 'react-ga'
import history from '@App/helpers/history'
import 'styles/styles.scss'
import './i18n'

if (location.protocol !== 'https:' && process.env.NODE_ENV !== 'development') {
  location.protocol = 'https:'
}

Sentry.init({
  dsn: 'https://5f015a305eb04791ae2545e6c36094ae@sentry.io/5183091',
  enabled: process.env.NODE_ENV !== 'development',
  environment: process.env.NODE_ENV,
  ignoreErrors: [
    'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: undefined.',
    'Invalid token specified',
    'Request failed with status code 400',
    'Request failed with status code 422',
  ],
  beforeSend(event, hint) {
    if (event.exception) {
      Sentry.showReportDialog({ eventId: event.event_id })
    }
    return event
  },
});

ReactGA.initialize('UA-114919165-4');

history.listen((location) => {
  ReactGA.set({ page: location.pathname })
  ReactGA.pageview(location.pathname)
})

setOriginalFetch(window.fetch)
window.fetch = progressBarFetch

ReactDOM.render(
  <Provider store={store}>
    <ProgressBar style={{
      backgroundColor: '#FF5454',
      position: 'fixed',
      top: '0',
      zIndex: 2147483647,
    }}
    />
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root') as HTMLElement,
)
